import axios from 'axios';
import { UserEntry } from '../../types/generated/userEntry';

export const deleteFlag = async (
    featureFlagKey: string,
    toastText?: {
        onSuccessText?: string;
        onPendingText?: string;
    }
) =>
    axios
        .delete(`/featureflag/features/${featureFlagKey}`, {
            headers: {
                'Toast-Pending-Text': toastText?.onPendingText,
                'Toast-Success-Text': toastText?.onSuccessText,
            },
        })
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
